module.exports = "<div class=\"stat-legend\"></div><div class=\"stat-sequence\"></div><div class=\"stat-chart\"></div><div class=\"hideCaptions\"><button ng-click=\"$ctrl.hideCaptions() \" class=\"btn\"><span ng-if=\"$ctrl.showCaptions\">{{:: 'Скрыть названия' | gettext }} </span><span ng-if=\"!$ctrl.showCaptions\">{{:: 'Показать названия' | gettext }}</span></button></div>"


//////////////////
// WEBPACK FOOTER
// ./src/stat/pie.component.html
// module id = 940
// module chunks = 0